import React from 'react';
import { List } from '@bynder/design-system';
import { useNavigableItem } from '../../KeyboardNavigation';
import type { AfterSelectAction } from '../../KeyboardNavigation/types';
import { getSpotlightResultClassName } from '../../helpers/getSpotlightResultClassName';

interface Props {
	dataId: string;
	dataSrc?: string;
	title: React.ReactNode;
	subtext?: React.ReactNode;
	thumbnail?: React.ReactElement;
	rightElements?: React.ReactNode;
	onSelect: () => void;
	afterSelect?: AfterSelectAction;
	className?: string;
}

export function ListRow({
	dataId,
	dataSrc,
	title,
	subtext,
	thumbnail,
	rightElements,
	onSelect,
	afterSelect,
	className,
}: Props) {
	const { isActive, itemRef, select } = useNavigableItem<HTMLLIElement>(onSelect, {
		afterSelect,
	});

	const classNames = [getSpotlightResultClassName('GENERIC'), className]
		.filter(Boolean)
		.join(' ');

	return (
		<li ref={itemRef} className={classNames} data-id={dataId} data-src={dataSrc}>
			<List.Item
				onClick={select}
				isSelected={isActive}
				thumbnail={thumbnail}
				subtext={subtext}
				rightElements={rightElements}
				{...{ tabIndex: -1 }}
			>
				{title}
			</List.Item>
		</li>
	);
}
